import { render, staticRenderFns } from "./PreciosArticulos.vue?vue&type=template&id=18a445c3&scoped=true&"
import script from "./PreciosArticulos.vue?vue&type=script&lang=js&"
export * from "./PreciosArticulos.vue?vue&type=script&lang=js&"
import style0 from "./PreciosArticulos.vue?vue&type=style&index=0&id=18a445c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a445c3",
  null
  
)

export default component.exports